import axios from "axios";
import { getContext } from "../../../Helpers/Context/Context";
import {
  LoanRepayment,
  LoanStatus,
} from "../../../Helpers/Enums/ApplicationStatus";
import { LoanDashboardModules } from "../../../Helpers/Enums/LoanDashboardModules";
import { RoleEnum } from "../../../Helpers/Enums/RoleEnum";
import { fetchAuthToken } from "../../../Helpers/Network/OAuthHandler";
import {
  GetLoanRequestDataExportToExcel,
  GetLoanRepaymentExportToExcel,
} from "../../../Helpers/APIEndPoints/EndPoints";
import fileDownload from "js-file-download";
import moment from "moment";
import notify, { ToastType } from "../../../Helpers/ToastNotification";

export const getStatusIdsForLoanDashboard = (
  module: LoanDashboardModules,
  loggedInAs: RoleEnum
) => {
  let statusIds = [];

  switch (module) {
    case LoanDashboardModules.All:
      switch (loggedInAs) {
        case RoleEnum.InternalTeam:
          statusIds = [
            LoanStatus.LoanModule_PendingWithInternalTeam,
            LoanStatus.LoanModule_PendingMemberLoanConfirmation,
            LoanStatus.LoanModule_RejectedByInternalTeam,
            LoanStatus.LoanModule_LoanAgreementPending,
            LoanStatus.LoanModule_LoanApplicationCancelledByMember,
            LoanStatus.LoanModule_MemberSignaturePending,
            LoanStatus.LoanModule_MemberSignatureVerificationPendingByInternalTeam,
            LoanStatus.LoanModule_MemberSignatureVerificationRejected,
            LoanStatus.LoanModule_LoanCommitteeApprovalPending,
            LoanStatus.LoanModule_MemberAgreementRejected,
            LoanStatus.LoanModule_LoanFinalApprovalPending,
            LoanStatus.LoanModule_LoanApplicationRejected,
            LoanStatus.LoanModule_DocumentGenerationPending,
            LoanStatus.LoanModule_LoanApplicationApproved,
            LoanStatus.LoanModule_LoanInprogress,
            LoanStatus.LoanModule_LoanCompleted,
          ];
          break;
        case RoleEnum.Member:
          statusIds = [
            LoanStatus.LoanModule_Draft,
            LoanStatus.LoanModule_SuretyApprovalPending,
            LoanStatus.LoanModule_SuretyAcceptedByMember,
            LoanStatus.LoanModule_SuretyRejectedByMember,
            LoanStatus.LoanModule_AllSuretyApproved,
            LoanStatus.LoanModule_PendingWithInternalTeam,
            LoanStatus.LoanModule_PendingMemberLoanConfirmation,
            LoanStatus.LoanModule_RejectedByInternalTeam,
            LoanStatus.LoanModule_LoanAgreementPending,
            LoanStatus.LoanModule_LoanApplicationCancelledByMember,
            LoanStatus.LoanModule_MemberSignaturePending,
            LoanStatus.LoanModule_MemberSignatureVerificationPendingByInternalTeam,
            LoanStatus.LoanModule_MemberSignatureVerificationRejected,
            LoanStatus.LoanModule_LoanCommitteeApprovalPending,
            LoanStatus.LoanModule_MemberAgreementRejected,
            LoanStatus.LoanModule_LoanFinalApprovalPending,
            LoanStatus.LoanModule_LoanApplicationRejected,
            LoanStatus.LoanModule_DocumentGenerationPending,
            LoanStatus.LoanModule_LoanApplicationApproved,
            LoanStatus.LoanModule_LoanInprogress,
            LoanStatus.LoanModule_LoanCompleted,
          ];
          break;
        case RoleEnum.Admin:
          statusIds = [
            LoanStatus.LoanModule_Draft,
            LoanStatus.LoanModule_SuretyApprovalPending,
            LoanStatus.LoanModule_SuretyAcceptedByMember,
            LoanStatus.LoanModule_SuretyRejectedByMember,
            LoanStatus.LoanModule_AllSuretyApproved,
            LoanStatus.LoanModule_PendingWithInternalTeam,
            LoanStatus.LoanModule_PendingMemberLoanConfirmation,
            LoanStatus.LoanModule_RejectedByInternalTeam,
            LoanStatus.LoanModule_LoanAgreementPending,
            LoanStatus.LoanModule_LoanApplicationCancelledByMember,
            LoanStatus.LoanModule_MemberSignaturePending,
            LoanStatus.LoanModule_MemberSignatureVerificationPendingByInternalTeam,
            LoanStatus.LoanModule_MemberSignatureVerificationRejected,
            LoanStatus.LoanModule_LoanCommitteeApprovalPending,
            LoanStatus.LoanModule_MemberAgreementRejected,
            LoanStatus.LoanModule_LoanFinalApprovalPending,
            LoanStatus.LoanModule_LoanApplicationRejected,
            LoanStatus.LoanModule_DocumentGenerationPending,
            LoanStatus.LoanModule_LoanApplicationApproved,
            LoanStatus.LoanModule_LoanInprogress,
            LoanStatus.LoanModule_LoanCompleted,
          ];
          break;
        case RoleEnum.EnrollmentCommittee:
          break;
        case RoleEnum.LoanCommittee:
          statusIds = [
            LoanStatus.LoanModule_PendingWithInternalTeam,
            LoanStatus.LoanModule_PendingMemberLoanConfirmation,
            LoanStatus.LoanModule_RejectedByInternalTeam,
            LoanStatus.LoanModule_LoanAgreementPending,
            LoanStatus.LoanModule_LoanApplicationCancelledByMember,
            LoanStatus.LoanModule_MemberSignaturePending,
            LoanStatus.LoanModule_MemberSignatureVerificationPendingByInternalTeam,
            LoanStatus.LoanModule_MemberSignatureVerificationRejected,
            LoanStatus.LoanModule_LoanCommitteeApprovalPending,
            LoanStatus.LoanModule_MemberAgreementRejected,
            LoanStatus.LoanModule_LoanFinalApprovalPending,
            LoanStatus.LoanModule_LoanApplicationRejected,
            LoanStatus.LoanModule_DocumentGenerationPending,
            LoanStatus.LoanModule_LoanApplicationApproved,
            LoanStatus.LoanModule_LoanInprogress,
            LoanStatus.LoanModule_LoanCompleted,
          ];
          break;
        case RoleEnum.HRHOD:
          statusIds = [
            LoanStatus.LoanModule_PendingWithHrHOD,
          ];
          break;
      }
      break;
    case LoanDashboardModules.Pending:
      switch (loggedInAs) {
        case RoleEnum.InternalTeam:
          statusIds = [LoanStatus.LoanModule_PendingWithInternalTeam];
          break;
        case RoleEnum.Member:
          statusIds = [
            LoanStatus.LoanModule_Draft,
            LoanStatus.LoanModule_AllSuretyApproved,
            LoanStatus.LoanModule_PendingMemberLoanConfirmation,
            LoanStatus.LoanModule_MemberSignatureVerificationRejected,
            //LoanStatus.LoanModule_RejectedByInternalTeam,
            // LoanStatus.LoanModule_LoanAgreementPending,
            
            LoanStatus.LoanModule_MemberSignaturePending,
            //LoanStatus.LoanModule_RejectedByHrHOD,
          ];
          break;
        case RoleEnum.Admin:
          break;
        case RoleEnum.EnrollmentCommittee:
          break;
        case RoleEnum.LoanCommittee:
          break;
        case RoleEnum.HRHOD:
          statusIds = [
            LoanStatus.LoanModule_PendingWithHrHOD,
          ];
          break;
      }
      break;
    case LoanDashboardModules.Agreement:
      switch (loggedInAs) {
        case RoleEnum.InternalTeam:
          statusIds = [
            LoanStatus.LoanModule_LoanAgreementPending,
            LoanStatus.LoanModule_MemberSignatureVerificationPendingByInternalTeam,
          ];
          break;
        case RoleEnum.Member:
          break;
        case RoleEnum.Admin:
          statusIds = [LoanStatus.LoanModule_LoanAgreementPending];
          break;
        case RoleEnum.EnrollmentCommittee:
          break;
        case RoleEnum.LoanCommittee:
          break;
        case RoleEnum.HRHOD:
          break;
      }
      break;
    case LoanDashboardModules.FinalDisbursement:
      switch (loggedInAs) {
        case RoleEnum.InternalTeam:
          break;
        case RoleEnum.Member:
          break;
        case RoleEnum.Admin:
          break;
        case RoleEnum.EnrollmentCommittee:
          break;
        case RoleEnum.LoanCommittee:
          statusIds = [
            LoanStatus.LoanModule_LoanCommitteeApprovalPending,
            LoanStatus.LoanModule_LoanFinalApprovalPending,
          ];
          break;
        case RoleEnum.HRHOD:
          break;
      }
      break;
    case LoanDashboardModules.AllRepayment:
      switch (loggedInAs) {
        case RoleEnum.InternalTeam:
          statusIds = [
            LoanRepayment.LoanRepayment_MemberApplyForLoanRepayment,
            LoanRepayment.LoanRepayment_InternalTeamAcceptLoanRepayment,
            LoanRepayment.LoanRepayment_InternalTeamRejectLoanRepayment,
            LoanRepayment.LoanRepayment_InternalTeamSendBackLoanRepayment,
            LoanRepayment.LoanRepayment_MemberPaymentDetailsPending,
            LoanRepayment.LoanRepayment_InternalTeamRepaymentDetailsApprovalPending,
            LoanRepayment.LoanRepayment_InternalTeamPaymentDetailsRequestSentBack,
            LoanRepayment.LoanRepayment_InternalTeamPaymentDetailsRequestReject,
            LoanRepayment.LoanRepayment_InternalTeamPaymentDetailsRequestAccept,
          ];
          break;
        case RoleEnum.Member:
          statusIds = [
            LoanRepayment.LoanRepayment_MemberApplyForLoanRepayment,
            LoanRepayment.LoanRepayment_InternalTeamAcceptLoanRepayment,
            LoanRepayment.LoanRepayment_InternalTeamSendBackLoanRepayment,
            LoanRepayment.LoanRepayment_InternalTeamRejectLoanRepayment,
            LoanRepayment.LoanRepayment_MemberPaymentDetailsPending,
            LoanRepayment.LoanRepayment_InternalTeamRepaymentDetailsApprovalPending,
            LoanRepayment.LoanRepayment_InternalTeamPaymentDetailsRequestAccept,
            LoanRepayment.LoanRepayment_InternalTeamPaymentDetailsRequestSentBack,
          ];
          break;
        case RoleEnum.Admin:
          statusIds = [
            LoanRepayment.LoanRepayment_MemberApplyForLoanRepayment,
            LoanRepayment.LoanRepayment_InternalTeamSendBackLoanRepayment,
            LoanRepayment.LoanRepayment_MemberPaymentDetailsPending,
            LoanRepayment.LoanRepayment_InternalTeamRepaymentDetailsApprovalPending,
            LoanRepayment.LoanRepayment_InternalTeamPaymentDetailsRequestAccept,
          ];
          break;
        case RoleEnum.EnrollmentCommittee:
          break;
        case RoleEnum.LoanCommittee:
          statusIds = [LoanRepayment.LoanRepayment_MemberApplyForLoanRepayment];
          break;
        case RoleEnum.HRHOD:
          statusIds = [LoanStatus.LoanModule_PendingWithHrHOD];
          break;
      }
      break;
    case LoanDashboardModules.PendingRepayment:
      switch (loggedInAs) {
        case RoleEnum.InternalTeam:
          statusIds = [
            LoanRepayment.LoanRepayment_MemberApplyForLoanRepayment,
            LoanRepayment.LoanRepayment_InternalTeamRepaymentDetailsApprovalPending,
          ];
          break;
        case RoleEnum.Member:
          statusIds = [
            LoanRepayment.LoanRepayment_MemberPaymentDetailsPending,
            LoanRepayment.LoanRepayment_InternalTeamSendBackLoanRepayment,
            LoanRepayment.LoanRepayment_InternalTeamPaymentDetailsRequestSentBack,
          ];
          break;
        case RoleEnum.Admin:
          statusIds = [
            LoanRepayment.LoanRepayment_MemberApplyForLoanRepayment,
            LoanRepayment.LoanRepayment_InternalTeamSendBackLoanRepayment,
            LoanRepayment.LoanRepayment_MemberPaymentDetailsPending,
            LoanRepayment.LoanRepayment_InternalTeamRepaymentDetailsApprovalPending,
          ];
          break;
        case RoleEnum.EnrollmentCommittee:
          break;
        case RoleEnum.LoanCommittee:
          statusIds = [LoanRepayment.LoanRepayment_MemberApplyForLoanRepayment];
          break;
        case RoleEnum.HRHOD:
          break;
      }
      break;
  }

  return statusIds;
};

export const getActionEditForLoanDashboard = (loggedInAs: RoleEnum) => {
  let editableStatuses = [];

  switch (loggedInAs) {
    case RoleEnum.InternalTeam:
      editableStatuses = [
        ...editableStatuses,
        ...getStatusIdsForLoanDashboard(
          LoanDashboardModules.Pending,
          loggedInAs
        ),
      ];
      editableStatuses = [
        ...editableStatuses,
        ...getStatusIdsForLoanDashboard(
          LoanDashboardModules.Agreement,
          loggedInAs
        ),
      ];
      break;
    case RoleEnum.Member:
      editableStatuses = [
        ...editableStatuses,
        ...getStatusIdsForLoanDashboard(
          LoanDashboardModules.Pending,
          loggedInAs
        ),
      ];
      //WIP
      // pending LoanModule_PendingMemberLoanConfirmation
      // agreement LoanModule_MemberSignaturePending
      break;
    case RoleEnum.Admin:
      break;
    case RoleEnum.EnrollmentCommittee:
      break;
    case RoleEnum.LoanCommittee:
      editableStatuses = [
        ...editableStatuses,
        ...getStatusIdsForLoanDashboard(
          LoanDashboardModules.Pending,
          loggedInAs
        ),
      ];
      editableStatuses = [
        ...editableStatuses,
        ...getStatusIdsForLoanDashboard(
          LoanDashboardModules.FinalDisbursement,
          loggedInAs
        ),
      ];
      break;
    case RoleEnum.HRHOD:
      editableStatuses = [
        ...editableStatuses,
        ...getStatusIdsForLoanDashboard(
          LoanDashboardModules.Pending,
          loggedInAs
        ),
      ];
      break;
  }

  editableStatuses = [...new Set(editableStatuses)];

  return editableStatuses;
};
export const getActionEditForLoanRepaymentDashboard = (
  loggedInAs: RoleEnum
) => {
  let editableStatuses = [];

  switch (loggedInAs) {
    case RoleEnum.InternalTeam:
      editableStatuses = [
        ...editableStatuses,
        ...getStatusIdsForLoanDashboard(
          LoanDashboardModules.PendingRepayment,
          loggedInAs
        ),
      ];

      break;
    case RoleEnum.Member:
      editableStatuses = [
        ...editableStatuses,
        ...getStatusIdsForLoanDashboard(
          LoanDashboardModules.PendingRepayment,
          loggedInAs
        ),
      ];
      break;
    case RoleEnum.Admin:
      break;
    case RoleEnum.EnrollmentCommittee:
      break;
    case RoleEnum.LoanCommittee:
      break;
    case RoleEnum.HRHOD:
      break;
  }

  editableStatuses = [...new Set(editableStatuses)];

  return editableStatuses;
};

export const ExportToExcel = async (
  count,
  searchText,
  sortColumn,
  sortDirection,
  MemberId,
  UnitCodeId,
  TypeofApplicantId,
  FromDate,
  ToDate,
  Status,
  IsApproval,
  IsAgreement,
  IsFinalDisbursement,
  currentRoleId,
  userId,
  activeTab
) => {
  const params = {
    resultsPerPage: count,
    searchText: searchText,
    sortColumn: sortColumn,
    sortDirection: sortDirection,
    MemberId: MemberId,
    UnitCodeId: UnitCodeId,
    TypeofApplicantId: TypeofApplicantId,
    FromDate: FromDate,
    ToDate: ToDate,
    Status: Status,
    IsApproval: IsApproval,
    IsAgreement: IsAgreement,
    IsFinalDisbursement: IsFinalDisbursement,
    RoleId: currentRoleId,
    UserId: userId,
    ActiveModule: [
      LoanDashboardModules.AllRepayment,
      LoanDashboardModules.PendingRepayment,
    ].includes(activeTab.module)
      ? 1
      : 0,
  };
  
  let token = await fetchAuthToken();
  let apiUrl = null;
  let fileName = null;
  if (activeTab.module === LoanDashboardModules.AllRepayment) {
    apiUrl = GetLoanRepaymentExportToExcel;
    fileName = "LoanRepaymentData";
  } else {
    apiUrl = GetLoanRequestDataExportToExcel;
    fileName = "LoanRequest";
  }
  if (apiUrl) {
    axios
      .request({
        responseType: "blob",
        method: "POST",
        url: apiUrl,
        data: params,
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
          "Access-Control-Allow-Headers": "*",
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
     
        fileDownload(
          response.data,
          `${fileName}_${moment(new Date()).format(moment.HTML5_FMT.DATE)}.xlsx`
        );
      })
      .catch((error) => {
      
        notify(ToastType.Error, "Failed to export data.");
      });
  } else {
    console.log("API URL not found.");
  }
};
